import { useEffect, useState } from 'react';
import { adminApi } from './api';

// Optional features switched on in the Worker's configuration (AI key, R2 bucket).
// Fetched once per page load and shared by every component that asks.
const NONE = { aiEnabled: false, r2Enabled: false };
let cached = null;

function loadCapabilities() {
  if (!cached) {
    cached = adminApi.getStats()
      .then(stats => ({ aiEnabled: Boolean(stats?.aiEnabled), r2Enabled: Boolean(stats?.r2Enabled) }))
      .catch(() => {
        cached = null; // retry next time (e.g. not signed in yet)
        return NONE;
      });
  }
  return cached;
}

export function useCapabilities() {
  const [capabilities, setCapabilities] = useState(NONE);

  useEffect(() => {
    let active = true;
    loadCapabilities().then(result => {
      if (active) setCapabilities(result);
    });
    return () => {
      active = false;
    };
  }, []);

  return capabilities;
}
